document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(".categories-container");
  let isDown = false;
  let startX;
  let scrollLeft;
  let isScrolling = false;

  // Scroll to active category immediately
  function scrollToActiveCategory() {
    const activeTab = document.querySelector(".category-item.active");
    if (activeTab) {
      const containerRect = container.getBoundingClientRect();
      const activeTabRect = activeTab.getBoundingClientRect();
      container.scrollLeft = activeTab.offsetLeft - (containerRect.width / 2 + activeTabRect.width / 2);
    }
  }

  const anchorTags = container.querySelectorAll("a");

  anchorTags.forEach((anchor) => {
    anchor.setAttribute("draggable", "false");
  });

  // Handle mouse events for scrolling
  container.addEventListener("mousedown", (e) => {
    isDown = true;
    isScrolling = false; // Reset scroll tracking
    startX = e.pageX - container.offsetLeft;
    scrollLeft = container.scrollLeft;
  });

  container.addEventListener("mousemove", (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - container.offsetLeft;
    const walk = (x - startX) * 2;

    if (Math.abs(walk) > 5) {
      // If movement exceeds 5px, treat it as scrolling
      isScrolling = true;
    }

    container.scrollLeft = scrollLeft - walk;
  });

  container.addEventListener("mouseup", () => {
    isDown = false;
    setTimeout(() => {
      isScrolling = false; // Reset after a short delay
    }, 100);
  });

  container.addEventListener("mouseleave", () => {
    isDown = false;
  });

  // Prevent clicks while scrolling
  document.querySelectorAll(".category-item").forEach((button) => {
    button.addEventListener("click", function (e) {
      if (isScrolling) {
        e.preventDefault();
        e.stopPropagation();
      }
    });
  });

  // Run on load and on window resize
  setTimeout(scrollToActiveCategory, 0);
});

function handleCategoryClick(url) {
  window.location.href = url;
}
